import {
    Action,
    ActionReducer,
    createFeature,
    createReducer,
    on,
} from '@ngrx/store';
import {
    loadUserBidHistory,
    loadUserBidHistorySuccess,
    loadUserBidHistoryFailure,
} from './user-bid-history.actions';
import { ListResponse } from '@viewbid/ts-angular-client';

export const userBidHistoryFeatureKey: string = 'userBidHistory';

export interface UserBidHistoryState {
    userBidHistory: ListResponse | undefined;
    loading: boolean;
    error: Error | null;
}

export const initialState: UserBidHistoryState = {
    userBidHistory: undefined,
    loading: false,
    error: null,
};

export const userBidHistoryReducer: ActionReducer<UserBidHistoryState, Action> =
    createReducer(
        initialState,
        on(
            loadUserBidHistory,
            (): UserBidHistoryState => ({
                ...initialState,
                loading: true,
            }),
        ),
        on(
            loadUserBidHistorySuccess,
            (
                state: UserBidHistoryState,
                { response }: { response: ListResponse },
            ): UserBidHistoryState => ({
                ...state,
                loading: false,
                userBidHistory: response,
            }),
        ),
        on(
            loadUserBidHistoryFailure,
            (
                state: UserBidHistoryState,
                { error }: { error: Error },
            ): UserBidHistoryState => ({
                ...state,
                loading: false,
                error: error,
            }),
        ),
    );

// eslint-disable-next-line
export const userBidHistoryFeature = createFeature({
    name: userBidHistoryFeatureKey,
    reducer: userBidHistoryReducer,
});
